import { useMemo } from 'react';
import { Divider, VStack, DataList, DataItem } from '@cad-arc';
import { ElasticUserAction } from '@mark43/cad-api';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { formatMonthDayYearHoursMinutesSeconds } from '../../common/helpers/utils';
import { ChangeViewDisplayName } from '../types';
import { extractChangeValues } from '../helpers';

export function FrDispositionSection({
    dispositions,
    reactivations,
    additionalDispositionsEnabled,
}: {
    dispositions?: ElasticUserAction;
    reactivations?: ElasticUserAction;
    additionalDispositionsEnabled: boolean;
}) {
    const dispositionData = useMemo(() => {
        const values = extractChangeValues(
            [
                ChangeViewDisplayName.PrimaryDisposition,
                ChangeViewDisplayName.AdditionalDisposition,
                ChangeViewDisplayName.Comments,
            ],
            dispositions?.changeViews
        );

        return {
            createdDate: dispositions
                ? formatMonthDayYearHoursMinutesSeconds(dispositions.createdDateUtc)
                : '-',
            primary: values[ChangeViewDisplayName.PrimaryDisposition],
            additional: values[ChangeViewDisplayName.AdditionalDisposition],
            comments: values[ChangeViewDisplayName.Comments],
        };
    }, [dispositions]);

    const reactivationsData = useMemo(() => {
        const values = extractChangeValues(
            [ChangeViewDisplayName.ReactivatedReason],
            reactivations?.changeViews
        );

        return {
            createdDate: reactivations
                ? formatMonthDayYearHoursMinutesSeconds(reactivations.createdDateUtc)
                : '-',
            comments: values[ChangeViewDisplayName.ReactivatedReason],
        };
    }, [reactivations]);

    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Dispositions" />
            <DataList>
                <DataItem dataKey="Primary">
                    {`${dispositionData.createdDate} ${dispositionData.primary}`}
                </DataItem>
                {additionalDispositionsEnabled && (
                    <DataItem dataKey="Additional">
                        {`${dispositionData.createdDate} ${dispositionData.additional}`}
                    </DataItem>
                )}
                <DataItem dataKey="Comments">{dispositionData.comments}</DataItem>
            </DataList>
            <Divider style={{ marginTop: '16px' }} />
            <SectionTitle title="Reactivation" />
            <DataList>
                <DataItem dataKey="Primary">{reactivationsData.createdDate}</DataItem>
                <DataItem dataKey="Comments">{reactivationsData.comments}</DataItem>
            </DataList>
        </VStack>
    );
}
